import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setActiveItem } from "../app/reducers/activePage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import PriceRangeSelector from "./Priceselector";
import Select from "./Select";
import Search from "./Search";
import axios from "axios";
import {
  setPropertyTypeOptions,
  setPriceOptions,
  setAreaOptions,
  setCityOptions,
  setFeaturesOptions,
  setSubTypeOptions,
  setKeywordsOptions,
} from "../app/reducers/selectedOptions";

import {
  setSearchResults,
  setSearchresultLoading,
  setSearchresultFailed,
  setSearchresultSucceeded,
} from "../app/reducers/searchedProperties";
const PagesNav = ({ openchatbot, setOpenChatbot }) => {
  const navigate = useNavigate();
  const [activeitem, setActiveItem] = useState("buy");
  const dispatch = useDispatch();
  const options = useSelector((state) => state.selectedOptions);
  const serached = useSelector((state) => state.searchedProperties);

  const pages = [
    {
      name: "BUY",
      value: "buy",
    },
    {
      name: "RENT",
      value: "rent",
    },
    // {
    //   name: "invest",
    //   value: "invest",
    // },
    {
      name: "PROJECTS",
      url: "/projects",
    },
  ];

  const citiesOfPakistan = [
    "Karachi",
    "Lahore",
    "Islamabad",
    "Rawalpindi",
    "Faisalabad",
    "Multan",
    "Hyderabad",
    "Quetta",
    "Peshawar",
    "Gujranwala",
    "Sialkot",
    "Sargodha",
    "Bahawalpur",
    "Sukkur",
    "Larkana",
    "Sheikhupura",
    "Jhang",
    "Rahim Yar Khan",
    "Mardan",
    "Gujrat",
    "Kasur",
    "Dera Ghazi Khan",
    "Sahiwal",
    // Add more cities as needed
  ];

  const propertyType = [
    "Homes",
    "Plots",
    "Commercial",
    "Agricultural Land",
    "Offices",
    "Shops",
    "Warehouses",
    "Factories",
    "Buildings",
    "Other",
  ];

  const area = [
    "5 Marla",
    "10 Marla",
    "1 Kanal",
    "2 Kanal",
    "5 kanal",
    "10 kanal",
    "20 kanal",
  ];

  const price = [
    "RS 10K  - RS 100K",
    "RS 100K - RS 1M",
    "RS 1M - RS 5M",
    "RS 5M - RS 10M",
    "RS 10M - RS 50M",
    "RS 50M - RS 100M",
    "Above 100M",
  ];

  const Beds = [
    "1 Bed",
    "2 Bed",
    "3 Bed",
    "4 Bed",
    "5 Bed",
    "6 Bed",
    "7 Bed",
    "8 Bed",
    "9 Bed",
    "10 Bed",
    "10 +",
  ];

  const findProperty = async () => {
    console.log("find property");
    // console.log(options, "options");
    try {
      //
      const queryString = new URLSearchParams(options).toString(); // Convert options object to query string
      const url = `https://rebhub-web-server.vercel.app/listing/getlistings?${queryString}`;
      const response = await axios.get(url);
      dispatch(setSearchresultLoading());
      dispatch(setSearchResults(response.data));
      dispatch(setSearchresultSucceeded());
      navigate("/searchedListing");
      return response.data;
    } catch (error) {
      dispatch(setSearchresultFailed(error.message));
      navigate("/searchedListing");
    }
  };
  console.log(serached, "searched");
  // const fetchData = createAsyncThunk("properties/fetchData", async () => {

  // });
  return (
    <div className="flex flex-col gap-4 px-8 ">
      <ul className="md:flex mx-auto rounded-md  justify-center items-center  bg-[#333940] gap-4 py-3 px-3 hidden  ">
        {pages?.map((item, index) => {
          const isActive = activeitem === item.name;

          return (
            <li
              key={index}
              className={`cursor-pointer transition-all min-w-[90px] text-center duration-300 border-white rounded-[5px] border ease-in ${
                isActive ? "bg-white text-[#363a41]  " : "text-white"
              }`}
              onClick={() => {
                setActiveItem(item.name);
                console.log(item.name);
              }}
            >
              <button className="text-[14px]  cursor-pointer  p-2  text-center    px-4 whitespace-nowrap ">
                {item.name}
              </button>
            </li>
          );
        })}
      </ul>

      <div className="bg-[#333940] p-4 rounded-md md:flex flex-col gap-3 hidden ">
        <div className="flex gap-3">
          <Select
            value="City"
            items={citiesOfPakistan}
            action={setCityOptions}
          />

          <div className="bg-white rounded-md w-full border-[#33393f] border  min-w-[370px] max-w-[370px] flex gap-1 p-[14px]  justify-center items-center">
            <input
              type="text"
              className="w-full focus:outline-none placeholder-[#2b2b2b] text-sm"
              placeholder="Search your keywords"
              onChange={(e) => dispatch(setKeywordsOptions(e.target.value))}
            />
          </div>
          <Select
            value="Property Type"
            items={propertyType}
            action={setPropertyTypeOptions}
          />
        </div>
        <div className="flex gap-3 w-full">
          <Select value="Area" items={area} action={setAreaOptions} />
          <Select value="Price" items={price} action={setPriceOptions} />
          <Select
            value="Beds & Baths"
            items={Beds}
            action={setFeaturesOptions}
          />
          <button
            className=" bg-[#2a9933] max-w-[180px] rounded-md w-full text-white  flex gap-1 p-3  justify-center items-center"
            onClick={() => findProperty()}
          >
            Find
          </button>
          {/* <PriceRangeSelector/> */}
        </div>
        <div className="bg-[#edf9ff] p-3 rounded-lg  flex gap-2 justify-between items-center">
          <div className="flex gap-2 items-center text-[14px]">
            <button className="bg-[#2a9933] text-white px-2 py-1 rounded-3xl text-[12px]">
              Try our Chatbot
            </button>
            <p>Tired of searching? Directly ask what you want to know. </p>
          </div>
          <svg
            fill="#000000"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            className="gpticon cursor-pointer"
            onClick={() => setOpenChatbot(true)}
          >
            <title>OpenAI icon</title>
            <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z"></path>
          </svg>
        </div>
      </div>

      <div className=" bg-black/70 right-0 absolute bottom-0 w-full flex  md:hidden flex-col gap-4 py-4">
        <p className="text-center text-[22px] text-white px-4">
          Search and estimate properties in Pakistan
        </p>
        <div className="flex gap-4 px-4 ">
          <button className=" bg-[#2a9933]  rounded-md w-full text-white  flex gap-1 p-3  justify-center items-center">
            Property search
          </button>
          <button className=" bg-[#2a9933] rounded-md w-full text-white  flex gap-1 p-3  justify-center items-center">
            Estimation value
          </button>
        </div>
        <div className="flex gap-4 px-4">
          <button className=" bg-[#2a9933]  rounded-md w-full text-white  flex gap-1 p-3  justify-center items-center">
            Projects
          </button>
        </div>
      </div>
    </div>
  );
};

export default PagesNav;
